import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  logo: {
    [theme.breakpoints.down("sm")]: {
      width: "inherit",
    },
  },
  completedTitle: {
    color: "#353535",
  },
  completedSubtitle: {
    color: "#353535",
    fontSize: 20,
    [theme.breakpoints.down("sm")]: {
      fontSize: 18,
    },
  },
  completedBody: {
    color: theme.palette.text.secondary,
  },
  wrapperContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    paddingBottom: theme.spacing(2),
  },
  character2: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    maxWidth: 300,
    marginBottom: 3,
  },
  leftContent: {
    backgroundColor: "transparent",
    height: "100%",
    width: "50%",
    marginTop: 0,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 0",
      width: "100%",
      minHeight: "90VH",
    },
  },
  rightContent: {
    width: "50%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      width: "100%",
      alignItems: "flex-start",
      alignContent: "flex-start",
    },
  },
  top: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(2),
  },
  blue: {
    color: "#6199BE",
  },
}));

export default useStyles;
